// 홈스쿨링 - 본사 - 지사별 통계
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import { InputGroup } from "react-bootstrap";
import { format, addDays } from "date-fns";

import axios from "@app/lib/axios";

import AgGridReactEx from "@app/components/AgGridReactEx";

import CardStatContent from "../Components/CardStatContent";

const totalBase = { nursery: 0, class: 0, playCount: 0, playCountSum: 0 };
const searchParamBase = {
    type: "",
    value: "",
};

const Branch = forwardRef(({ isRoleBranch, selectedBranch, statAll, onNurseryUniqSelected }, ref) => {
    const [stat, setStat] = useState(false);
    const [total, setTotal] = useState(totalBase);
    const [tableData, setTableData] = useState(false);
    const [searchParam, setSearchParam] = useState({ ...searchParamBase });

    const defaultColDef = {
        editable: false,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
    };
    const listColumn = [
        {
            headerName: "No",
            field: "id",
            width: 80,
            minWidth: 50,
            valueGetter: "node.rowIndex + 1",
        },
        {
            headerName: "지사명",
            field: "branchName",
            width: 100,
            cellClass: "text-left",
        },
        {
            headerName: "원명",
            field: "nurseryUniqName",
            width: 100,
            cellClass: "text-left",
        },
        {
            headerName: "계약반 수",
            field: "classCount",
            width: 100,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "콘텐츠 실행 수",
            field: "playCountSum",
            width: 100,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
    ];

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const excelData = {
                fileName: `토모노트_${selectedBranch.name}`,
                sheets: [
                    {
                        name: "원",
                        title: `원 콘텐츠 사용 통계`,
                        columnTitle: [
                            "지사명",
                            "원명",
                            "계약반 수",
                            `콘텐츠 실행 수`,
                        ],
                        data: tableData ? tableData.map((s) => [s.branchName, s.nurseryUniqName, s.classCount, s.playCountSum || 0]) : [],
                    },
                ],
            };
            callback(null, excelData);
        },
    }));
    useEffect(() => {
        return () => {};
    }, []);
    useEffect(() => {
        applyStat(statAll);
        return () => {};
    }, [statAll, selectedBranch]);

    const applyStat = (statAll) => {
        const total = { ...totalBase };
        let stat = [];

        if (statAll && statAll.length > 0) {
            if (selectedBranch.id == 0) {
                stat = statAll;
            } else {
                stat = statAll.filter((n) => n.branchId == selectedBranch.id);
            }
            total.nursery = stat.length;
            stat.forEach((s) => {
                total.class += s.classCount || 0;
                total.playCount += s.playCount || 0;
                total.playCountSum += s.playCountSum || 0;
            });
        }
        applyData({ ...searchParamBase }, stat);
        setStat(stat);
        setTotal(total);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };
    const onSearch = () => {
        applyData(searchParam, stat);
    };

    const applyData = (searchParam, list) => {
        var tableData = listSearch(searchParam, list);

        setTableData(tableData);
        setSearchParam(searchParam);
    };

    const searchField = isRoleBranch ? ["nurseryUniqName"] : ["branchName", "nurseryUniqName"];
    const listSearch = (searchParam, list) => {
        var tableDataNew = [];
        if (!searchParam.value) {
            tableDataNew = list;
        } else {
            list.forEach((item) => {
                searchField.forEach((field) => {
                    if (item[field] && item[field].indexOf(searchParam.value) >= 0) {
                        tableDataNew.push(item);
                    }
                });
            });
        }
        return tableDataNew;
    };

    const onRowSelected = (e) => {
        if (onNurseryUniqSelected && e && e.data) {
            onNurseryUniqSelected(e.data);
        }
    };

    return (
        <div className="stat-branch-content">
            <div className="row mb-3">
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                    <CardStatContent id="1" title="계약 원" titleBgClass="bg-tomonote">
                        전체 : {total.nursery.toLocaleString()}
                    </CardStatContent>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                    <CardStatContent id="2" title="계약 클래스" titleBgClass="bg-tomonote">
                        전체 : {total.class.toLocaleString()}
                    </CardStatContent>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                    <CardStatContent id="3" title="콘텐츠 실행 수" titleBgClass="bg-tomonote">
                        합계 : {total.playCountSum.toLocaleString()}
                    </CardStatContent>
                </div>
            </div>
            <div className="row mb-1">
                <div className="col-xl-8 col-lg-7 col-md-6 col-sm-12 col-12 pl-4 d-flex">
                    <h5 className="mb-0" style={{ alignSelf: "end" }}>
                        <span>
                            {tableData ? tableData.length.toLocaleString() : "0"} / {total.nursery.toLocaleString()}
                        </span>
                    </h5>
                </div>
                <div className="col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12">
                    <InputGroup className="input-group my-group">
                        <input
                            className="form-control"
                            type="text"
                            value={searchParam.value}
                            placeholder={isRoleBranch ? "원명" : "지사명|원명"}
                            onChange={(e) => {
                                const param = { ...searchParam };
                                param.value = e.target.value;
                                setSearchParam(param);
                            }}
                            onKeyPress={handleKeyPress}
                        />
                        <InputGroup.Append>
                            <input type="submit" className="btn btn-primary" value="검색" onClick={onSearch} />
                        </InputGroup.Append>
                    </InputGroup>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <AgGridReactEx
                        defaultColDef={defaultColDef}
                        columnDefs={listColumn}
                        headerHeight={40}
                        height={550}
                        rowData={tableData}
                        onRowClicked={(e) => {
                            onRowSelected(e);
                        }}
                        pagination={true}
                        overlayNoRowsTemplate={`<span>통계 자료가 없습니다.</span>`}
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-12">
                    <div className="text-xs text-primary float-right">
                        ※ 정확한 통계 제공을 위해 현재 날짜의 전일까지의 통계만 제공됩니다.
                        <br />※ 당해 학년도의 3월~2월까지의 통계 데이터만 제공됩니다.
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Branch;
